function fn_comp_visual() {
    var $fn = $(".comp_visual"),
        $slider = $fn.find("[data-visual-slider]"),
        $slider_caption = $fn.find("[data-visual-caption]"),
        $slider_nav = $fn.find("[data-visual-nav]"),
        $slider_autoplay = $slider.data("visual-slider"),
        $caption_nav  = $fn.find("[data-caption-nav]");

    var $autoplay = true;
    if ($slider_autoplay == "0" || $slider_autoplay == "") {
        $autoplay = false;
    }
    if ($slider_caption.children().length > 1) {
        $slider_caption.slick({
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: false,
            asNavFor: $slider,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        adaptiveHeight: false
                    }
                }
            ]
        });
    } else {
        $slider_caption = false;
    }

    if ($slider.children().length > 1) {
        $slider.slick({
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            autoplay: $autoplay,
            autoplaySpeed: $slider_autoplay,
            arrows: false,
            pauseOnHover: false,
            asNavFor: $slider_caption,
            dots: true
        });
        $slider.on('beforeChange', function(){
            $(this).find(".slick-active").next().find("img").addClass("lazyload");
        });
        $slider.on('afterChange', function(){
            $(this).find(".slick-active").find("img").addClass("lazyload");
        });
    }

    $fn.on("click", "[data-action-id]", function(){
        var $id = $(this).data("action-id"),
            $href = $(this).attr("href");

        $("[data-anchor-elm]").filter('[data-anchor-elm="'+$href+'"]').find(".wrp_content_nav [data-action-id]").filter('[data-action-id="'+$id+'"]').trigger("click");
    });

    if ($slider_nav.length) {
        $slider_nav.find(".icon--chevron-left").on("click", function(e) {
            e.preventDefault();
            $slider.slick("slickPrev");
        });

        $slider_nav.find(".icon--chevron-right").on("click", function(e) {
            e.preventDefault();
            $slider.slick("slickNext");
        });
    }

    if ($caption_nav.length && $slider_caption !== false) {
        $caption_nav.filter('[data-caption-nav="prev"]').on("click", function(e) {
            e.preventDefault();
            $slider_caption.slick("slickPrev");
        });

        $caption_nav.filter('[data-caption-nav="next"]').on("click", function(e) {
            e.preventDefault();
            $slider_caption.slick("slickNext");
        });
    }

    $fn.find("[data-visual-scroll]").on("click", function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $fn.next().offset().top - ($("#layout_header").innerHeight()-1)
        }, 500);
    });
}